import { render, staticRenderFns } from "./Shopname.vue?vue&type=template&id=7fa252da"
import script from "./Shopname.vue?vue&type=script&lang=js"
export * from "./Shopname.vue?vue&type=script&lang=js"
import style0 from "./Shopname.vue?vue&type=style&index=0&id=7fa252da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports